import { API_URL as API } from "../config";

const CHUNK_SIZE = 2 * 1024 * 1024; // 2MB chunks

export async function uploadFile(file, authFetch, onProgress) {
  if (file.size <= CHUNK_SIZE) {
    // Small file: use direct upload
    const formData = new FormData();
    formData.append("file", file);
    const res = await authFetch(`${API}/api/admin/upload`, { method: "POST", body: formData });
    if (!res.ok) throw new Error("Upload failed");
    return await res.json();
  }

  // Large file: use chunked upload
  const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

  // 1. Init
  const initRes = await authFetch(`${API}/api/admin/upload/init`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ filename: file.name, total_chunks: totalChunks }),
  });
  if (!initRes.ok) throw new Error("Failed to start upload");
  const { upload_id } = await initRes.json();

  // 2. Upload chunks
  for (let i = 0; i < totalChunks; i++) {
    const start = i * CHUNK_SIZE;
    const end = Math.min(start + CHUNK_SIZE, file.size);
    const chunk = file.slice(start, end);

    const formData = new FormData();
    formData.append("file", chunk, `chunk_${i}`);
    formData.append("upload_id", upload_id);
    formData.append("chunk_index", String(i));

    const chunkRes = await authFetch(`${API}/api/admin/upload/chunk`, {
      method: "POST",
      body: formData,
    });
    if (!chunkRes.ok) throw new Error(`Chunk ${i + 1}/${totalChunks} failed`);
    if (onProgress) onProgress(Math.round(((i + 1) / totalChunks) * 100));
  }

  // 3. Complete
  const completeRes = await authFetch(`${API}/api/admin/upload/complete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ upload_id, filename: file.name }),
  });
  if (!completeRes.ok) throw new Error("Failed to finalize upload");
  return await completeRes.json();
}
